import { PickResult, PickResultEntry } from '@sas-dvr/ltjs-commons';

export function filterEntriesByType<T extends PickResultEntry>(
  pickResults: (PickResult | null)[] | null,
  entryType: new () => T
): T[] {
  if (!pickResults || !pickResults.length) return [];

  const result = pickResults[0];
  if (!result) return [];

  const entries = result.getEntries();
  if (!entries) return [];

  // Find the first available DataGridPickResultEntry
  return entries.filter((item): item is T => item instanceof entryType);
}
